import React from 'react';
import localization from '../helpers/localization.js';
import SaunaImageContainer from '../containers/SaunaImageContainer';

const selectInstallButtonStyle = "selectInstallButton";
const installSelectionPage = ({ installCategories, installWanted, installDescription, estimatedDate, changeInstallDescription, changeDesiredDate, changeInstallProjectType, installPostaCodeChanged, installAvailable, setInstallWanted, changeCategorySelection, prevPage, nextPage }) => {
    let noInstallstyle = selectInstallButtonStyle + (installWanted === false ? " selectInstallButtonSelected" : " selectInstallButtonNotSelected");
    let installSelectedStyle = selectInstallButtonStyle + (installWanted === true ? " selectInstallButtonSelected" : " selectInstallButtonNotSelected");

    return (<div className="page">
        <SaunaImageContainer />
        <div className="selectionPanel installPanel">
        <h2>{localization.wantInstall}</h2>
          <div className="installChoiceRow">
            <button type="button" className={installSelectedStyle} onClick={() => setInstallWanted(true)}><span className="installIcon">✓</span><strong>Haluan asennuksen</strong><small>Pyydämme asennuksesta erillisen hinnan.</small></button>
            <button type="button" className={noInstallstyle} onClick={() => setInstallWanted(false)}><span className="installIcon">⌁</span><strong>{localization.installSelf}</strong><small>Huolehdin asennuksesta itse.</small></button>
          </div>
        <InstallLocationControls show={installWanted} installAvailable={installAvailable} installPostaCodeChanged={installPostaCodeChanged} ></InstallLocationControls>
        <InstallControls show={installWanted === true && installAvailable == "available"} estimatedDate={estimatedDate} changeDesiredDate={changeDesiredDate} changeInstallDescription={changeInstallDescription} installDescription={installDescription} installCategories={installCategories} changeInstallProjectType={changeInstallProjectType} categorySelectionChanged={changeCategorySelection}></InstallControls>
        </div>
        <div className="changePhaseRow">
            <span className="orangeButton changePhaseButton" onClick={() => { prevPage() }}> <span className="buttonTxt">&#8592;  {localization.prevPhase}</span></span>
            <span className="orangeButton changePhaseButton" onClick={() => { nextPage() }}> <span className="buttonTxt"> {localization.nextPhase} &#8594;</span></span>
        </div>

    </div>);

}
export default installSelectionPage;



const InstallLocationControls = ({show, installAvailable,postalCode,installPostaCodeChanged}) => {
    if (show === true) {
        let installLocationText;
        if (installAvailable == "available")
            installLocationText = localization.installPossibleInArea;
        else if (installAvailable ==="notAvailable")
            installLocationText = localization.installNotPossibleInArea;
        else if (installAvailable == "checking")
        {
            installLocationText = localization.checking;
        }
        else
            installLocationText = localization.fillInPostalCodeForInstall;
        return (
            <div>
                <label htmlFor="installPostalNumberLabel">{localization.fillInstallPostalCode}.</label>
                <input id="installPostalNumberLabel" type="text" name="postalNumber" type="text" placeholder={localization.postalNumberPlaceHolder} value={postalCode} onChange={(e) => { if (e.currentTarget.value.length == 5) installPostaCodeChanged(e.currentTarget.value) }} />
                <label>{installLocationText}</label>
            </div>
        );
    }
    else
        return (<div></div>);
}






const InstallControls = ({ show, installDescription, changeInstallDescription, installCategories, changeDesiredDate, estimatedDate, changeInstallProjectType, categorySelectionChanged }) => {
    if (show) { 
        return (
            <div className="installSelections">
            <select onChange={(e) => changeInstallProjectType(e.target.value)}>
                <option value="newConstruction" >{localization.newConstruction}</option>
                <option value="renovation" >{localization.renowation}</option>
            </select>
                <fieldset className="installCategoryFieldset">
                    <legend>{localization.chooseInstallProducts}</legend>
                    <div className="installCategoryGrid">
                    {
                        installCategories.map(category =>
                            <label className={"installCategoryOption" + (category.selected ? " isSelected" : "")} htmlFor={category.name+"_select"} key={category.name}>
                                <input id={category.name+"_select"} type="checkbox" checked={Boolean(category.selected)} onChange={(e) => categorySelectionChanged(category.name, e.currentTarget.checked)} />
                                <span className="installCategoryCheck" aria-hidden="true">✓</span>
                                <span className="installCategoryLabel">{localization[category.localizationKey]}</span>
                            </label>
                        )
                    }
                    </div>
                </fieldset>

                <label htmlFor="installDateInput">{localization.installDate}</label>
                <input id="installDateInput" type="date" onChange={e => changeDesiredDate(e.currentTarget.value)}></input>

            <label>{localization.installExtraDescription}</label>
            <textarea rows="4" value={installDescription} onChange={(e) => changeInstallDescription(e.currentTarget.value)}></textarea>
        </div>
    );
    }
    else
        return <div></div>

}
